import React, { useState, type ReactElement } from "react";
import ImageCarousel, { type CarouselSlide } from "./ImageCarousel";
import factionlessart from "../../assets/img/landing/factionlessart.webp";
import factionlessartHd from "../../assets/img/landing/factionlessart_hd.webp";
import factionlessart2 from "../../assets/img/landing/factionlessart2.webp";
import factionlessart2Hd from "../../assets/img/landing/factionlessart2_hd.webp";
import celestialart from "../../assets/img/landing/celestialart.webp";
import celestialartHd from "../../assets/img/landing/celestialart_hd.webp";
import ephemeralart from "../../assets/img/landing/ephemeralart.webp";
import ephemeralartHd from "../../assets/img/landing/ephemeralart_hd.webp";
import infernalart from "../../assets/img/landing/infernalart.webp";
import infernalartHd from "../../assets/img/landing/infernalart_hd.webp";
import harstad from "../../assets/img/landing/battlegrounds/harstad.webp";
import harstadHd from "../../assets/img/landing/battlegrounds/harstad_hd.webp";
import splashart1 from "../../assets/img/landing/splashart1.webp";
import splashart1Hd from "../../assets/img/landing/splashart1_hd.webp";
import splashart2 from "../../assets/img/landing/bg_battle.webp";
import splashart2Hd from "../../assets/img/landing/bg_battle_hd.webp";

const ART_SLIDES: CarouselSlide[] = [
  { alt: "World art — scene one", mobile: factionlessart, desktop: factionlessartHd },
  { alt: "World art — scene two", mobile: celestialart, desktop: celestialartHd },
  { alt: "World art — scene three", mobile: ephemeralart, desktop: ephemeralartHd },
  { alt: "World art — scene four", mobile: harstad, desktop: harstadHd },
  { alt: "World art — scene five", mobile: factionlessart2, desktop: factionlessart2Hd },
  { alt: "World art — scene six", mobile: splashart1, desktop: splashart1Hd },
  { alt: "World art — scene seven", mobile: splashart2, desktop: splashart2Hd },
  { alt: "World art — scene eight", mobile: infernalart, desktop: infernalartHd },
];

const ART_INTERVAL_MS = 5000;

/**
 * Standalone art gallery — same chrome as Gameplay (`carousel-section` + ImageCarousel).
 */
const ArtSection = (): ReactElement => {
  const [stripExpanded, setStripExpanded] = useState(false);

  return (
    <section
      className={`art-section carousel-section carousel-section--expandable${
        stripExpanded ? " carousel-section--strip-expanded" : ""
      }`}
      aria-labelledby="art-section-heading"
    >
      <p className="section-label" id="art-section-heading">
        Art
      </p>
      <ImageCarousel
        slides={ART_SLIDES}
        intervalMs={ART_INTERVAL_MS}
        ariaLabel="Dfiance world art gallery"
        expandOnDoubleTapMobile
        desktopStripExpand={{
          expanded: stripExpanded,
          onToggle: () => setStripExpanded((v) => !v),
        }}
      />
    </section>
  );
};

export default ArtSection;
